////////LIBRARY/////////
import React from 'react'
import { map, isUndefined } from 'lodash'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import { SelectInput, SelectInputWrapper } from '../../../../../theme/GlobalCss'

//////STYLED//////
const RowPerPageWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(min-content, max-content));
	grid-column-gap: 5px;
	justify-content: center;
	align-items: center;
	p {
		margin: 0px;
	}
`
const SelectInputCustom = styled(SelectInput)`
	cursor:pointer;
	line-height: 29px;

	}
`
//////STYLED//////

const RowPerPage = ({ totalRow, register }) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const options = ['20', '50', '100', '250']

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<RowPerPageWrapper>
			<p>{translations['common__text__rowPerPage']} :</p>
			<SelectInputWrapper>
				<SelectInputCustom name="rowPerPage" ref={register()}>
					{map(options, (opt, key) => (
						<option key={key} value={opt}>
							{opt}
						</option>
					))}
				</SelectInputCustom>
			</SelectInputWrapper>
			<p>{`${translations['common__text__result_on_quantity']} ${!isUndefined(totalRow) ? totalRow : 0}`}</p>
		</RowPerPageWrapper>
	)
}

RowPerPage.propTypes = {}

RowPerPage.defaultPropTypes = {}

export default RowPerPage
